module.exports = __webpack_public_path__ + "static/media/icon_question_mark.67b99ed2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/game/textures/icon_question_mark.png
 ** module id = 617
 ** module chunks = 0
 **/